interface SvgCloseProps {
  className?: string;
  width?: number | string;
  height?: number | string;
}
export default function SvgClose(props: SvgCloseProps) {
  return <svg width={24} height={24} viewBox="0 0 24 24" fill="none" role="img" {...props}><path d="M18 7.05L16.95 6L12 10.95L7.05 6L6 7.05L10.95 12L6 16.95L7.05 18L12 13.05L16.95 18L18 16.95L13.05 12L18 7.05Z" fill="currentColor" /></svg>;
}